import LinkNoPrefetch from '@/components/link-noprefetch';
import Image from 'next/image';
import { formatShotDate } from '@/app/utils/date.utils';

function Announcement({ title, description, type1, announcementDate, url = '/' }) {
    const { month, day, year } = formatShotDate(announcementDate);

    const iconMap = {
        announcement: '/assets/icons/annonce-icon-megaphone.svg',
        important: '/assets/icons/annonce-icon-important.svg',
        release: '/assets/icons/annonce-icon-releases.svg'
    };

    const iconSrc = iconMap[type1] || '/assets/icons/annonce-icon-megaphone.svg';

    return (
        <div className="max-w-3xl px-8 py-6">
            <div className="mb-4 flex">
                <div className="relative m-[3px_18px_10px_0] flex size-10 min-w-[40px] items-center justify-center rounded-full bg-blue-450">
                    <Image
                        src={iconSrc}
                        width={12}
                        height={18}
                        sizes="18px"
                        alt={type1 + ': ' + title}
                    />
                </div>
                <div>
                    <div className="d-block text-sm font-bold">
                        {day} {month}, 20{year}
                    </div>
                    <h3>
                        <LinkNoPrefetch className="text-section-color" href={url}>
                            {title}
                        </LinkNoPrefetch>
                    </h3>
                    <p className="pt-2">{description}</p>
                </div>
            </div>
        </div>
    );
}

export default Announcement;
